export const data = [
  {
    name: "Ingenieria Informatica",
    date: "2020 - 2022",
    detail: "Universidad Tecnológica de Chile INACAP",
    img: "https://mir-s3-cdn-cf.behance.net/projects/404/e1ec4f81564541.Y3JvcCw0MjEsMzI5LDE1OTgsMTc1.jpg",
  },
  {
    name: "Analista Programador",
    date: "2018 - 2020",
    detail: "Centro de Formacion Técnica Inacap",
    img: "https://mir-s3-cdn-cf.behance.net/projects/404/e1ec4f81564541.Y3JvcCw0MjEsMzI5LDE1OTgsMTc1.jpg",
  },
];
